export class EstimateTotal {
    public constructor(
        laborTotal: number = 0,
        laborTaxPercentage: number = 0,
        laborTaxTotal: number = 0,
        partTotal: number = 0,
        partTaxPercentage: number = 0,
        partTaxTotal: number = 0,
        supplyTotal: number = 0,
        supplyTaxPercentage: number = 0,
        supplyTaxTotal: number = 0
    ) {
        this.laborTotal = laborTotal;
        this.laborTaxPercentage = laborTaxPercentage;
        this.laborTaxTotal = laborTaxTotal;
        this.partTotal = partTotal;
        this.partTaxPercentage = partTaxPercentage;
        this.partTaxTotal = partTaxTotal;
        this.supplyTotal = supplyTotal;
        this.supplyTaxPercentage = supplyTaxPercentage;
        this.supplyTaxTotal = supplyTaxTotal;
    }

    public laborTotal: number;
    public laborTaxPercentage: number;
    public laborTaxTotal: number;
    public partTotal: number;
    public partTaxPercentage: number;
    public partTaxTotal: number;
    public supplyTotal: number;
    public supplyTaxPercentage: number;
    public supplyTaxTotal: number;
}
